import { render, staticRenderFns } from "./ContextIugu.vue?vue&type=template&id=df7f82b8&"
import script from "./ContextIugu.vue?vue&type=script&lang=ts&"
export * from "./ContextIugu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports